/**
 * @generated SignedSource<<1622941c19dc1314235c56c2fae75257>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type YourRound_Booking$data = {
  readonly durationMins?: number | null | undefined;
  readonly id: string;
  readonly rounds: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly shareId: string | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly publicBookingPermissionSet: {
          readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
        } | null | undefined;
        readonly type: FacilityType;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureRound_Booking" | "SelectActivityManagementRound_Booking" | "SelectRound_Booking">;
  readonly " $fragmentType": "YourRound_Booking";
};
export type YourRound_Booking$key = {
  readonly " $data"?: YourRound_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"YourRound_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "YourRound_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectRound_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConfigureRound_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SelectActivityManagementRound_Booking"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "prePaymentRequirement",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationMins",
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "5b44a8f3c857b2ca8f869b260944718f";

export default node;
